import { Box, Button, Tooltip, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";

interface AddButtonProps {
  urlName: string;
  label?: string;
}

const AddButton = (props: AddButtonProps) => {
  return (
    <Box>
      <Link to={props.urlName}>
        <Tooltip title={props?.label || "Añadir"}>
          <Button  variant="contained"  color="primary" sx={{ borderRadius: "15px" }} startIcon={<AddIcon />}>
            <Typography
              fontWeight={500}
              fontSize={"16px"}
              lineHeight={"24px"}
              letterSpacing={"0.2px"}
              textTransform={"capitalize"}
            >
              {props?.label || "Añadir"}
            </Typography>
          </Button>
        </Tooltip>
      </Link>
    </Box>
  );
};

export default AddButton;
